import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { translate } from 'components/Translation';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import CustomInput from 'components/CustomInput/CustomInput';
import emailNotValid from 'utils/objectsValidation/emailNotValid';
import Departments from 'views/Users/Details/UserDetails/dialogs/subcomponents/Departments';
import { SingleDepartment } from 'utils/api/models/departments/singleDepartment';
import { PHONE_NUMBER_LENGTH } from 'utils/const/numbers';

// @ts-ignore
const useStyles = makeStyles(styles);

type IEditUserProps = {
	handleClose: () => void;
	handleSaveData: () => void;
	formData: {
		username: string;
		email: string;
		departmentId: string;
		contactNumber: string;
	};
	setFormData: (key: string, value: string) => void;
	departments: SingleDepartment[];
	isEnterprise: boolean;
};

const EditUser = ({
	handleClose,
	formData,
	setFormData,
	departments,
	handleSaveData,
	isEnterprise,
}: IEditUserProps) => {
	const classes = useStyles();
	const isValid = React.useMemo(() => {
		return (
			['username', 'email'].every((key) => formData[key].length > 0) &&
			!emailNotValid(formData.email) &&
			(formData.contactNumber.length === 0 || formData.contactNumber.length === PHONE_NUMBER_LENGTH)
		);
	}, [formData]);

	const departmentsElem = (
		<Departments
			departments={departments}
			onClick={(departmentId) => {
				let value = departmentId;
				if (formData.departmentId === departmentId) {
					value = '';
				}

				setFormData('departmentId', value);
			}}
			checked={formData.departmentId}
		/>
	);

	const handleOnChange = (event: React.ChangeEvent<{ value: string }>): void => {
		event.persist();
		const value = event.target.value.replace(/[^0-9]+/g, '');
		if (value.length <= PHONE_NUMBER_LENGTH) {
			setFormData('contactNumber', value);
		}
	};

	return (
		<CustomDialog
			header={translate('users.details.editUserInformation')}
			isOpen
			hideDialog={handleClose}
			dialogBody={
				<div className={classes.dialogBody}>
					<CustomInput
						labelText={translate('user.name')}
						inputProps={{
							value: formData.username,
							onChange: ({ target: { value } }: React.ChangeEvent<HTMLSelectElement>) =>
								setFormData('username', value),
						}}
						id="username-input"
						formControlProps={{ fullWidth: true }}
					/>
					<CustomInput
						labelText={translate('email.address')}
						inputProps={{
							value: formData.email,
							onChange: ({ target: { value } }: React.ChangeEvent<HTMLSelectElement>) =>
								setFormData('email', value),
						}}
						id="email-input"
						formControlProps={{ fullWidth: true }}
					/>
					<CustomInput
						labelText={translate('contact.number')}
						inputProps={{
							value: formData.contactNumber,
							onChange: handleOnChange,
						}}
						id="contact-number-input"
						formControlProps={{ fullWidth: true }}
					/>
					{!isEnterprise && departmentsElem}
				</div>
			}
			rightSideButtons={[
				{
					text: translate('cancel'),
					color: 'tertiary-light',
					onClick: () => handleClose(),
					id: 'cancel-button',
				},
				{
					text: translate('save'),
					color: 'primary-light',
					onClick: handleSaveData,
					disabled: !isValid,
				},
			]}
		/>
	);
};

export default EditUser;
